'use client'

import { ContentfulLivePreview } from '@contentful/live-preview'
import { useEffect } from 'react'

/**
 * Initializes Contentful Live Preview and subscribes to save events
 * Only runs when draft mode is enabled
 *
 * Note: revalidationSecret should be a public env var or passed via a different method
 * For now, we'll use a placeholder that can be configured
 */
export function ContentfulLivePreviewScript() {
  useEffect(() => {
    ContentfulLivePreview.init({
      locale: 'en-US',
      debugMode: true,
      enableLiveUpdates: true,
      enableInspectorMode: true,
    })

    ContentfulLivePreview.subscribe('save', {
      callback: () => {
        // eslint-disable-next-line no-console
        console.log('Save event detected, reloading...')
        window.location.reload()
      },
    })
  }, [])

  return null
}
